import * as tslib_1 from "tslib";
const pe = require('@hughfdjackson/promise-extras');
import { injectable } from "../Di";
export var PromiseStatus;
(function (PromiseStatus) {
    PromiseStatus[PromiseStatus["RESOLVED"] = "resolved"] = "RESOLVED";
    PromiseStatus[PromiseStatus["REJECTED"] = "rejected"] = "REJECTED";
})(PromiseStatus || (PromiseStatus = {}));
let PromiseService = class PromiseService {
    /**
     * @param data
     * @returns {Promise<any>}
     */
    allSettled(...data) {
        return pe.array.allSettled(data);
    }
    /**
     * @param promises
     * @returns {function(...[any]): any}
     */
    chain(promises) {
        return (...args) => {
            if (promises.length === 0) {
                return Promise.resolve(args.length > 0 ? args[0] : null);
            }
            var promise = promises[0](...args);
            for (var i = 1; i < promises.length; i++) {
                promise = promise.then(promises[i]);
            }
            return promise;
        };
    }
    /**
     * @param data
     * @returns {Promise<T>}
     */
    hashAll(entry) {
        return pe.array.objectAll(entry);
    }
    /**
     * @param data
     * @returns {Promise<T>}
     */
    hashSettled(entry) {
        const list = Object.keys(entry).map(entryName => entry[entryName]);
        return this.allSettled(...list).then(results => results.reduce((map, result, index) => map[Object.keys(entry)[index]] = result, {}));
    }
    /**
     * @param timeout
     * @returns {Promise<any>}
     */
    delay(timeout) {
        return pe.delay(timeout);
    }
};
PromiseService = tslib_1.__decorate([
    injectable
], PromiseService);
export { PromiseService };
